import Reveal from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { MENU_COLLECTIONS } from "../data/menu";
import { WA } from "../data/site";

const MenuCard = ({ item, idx, cid }) => (
    <Reveal className="h-full" delay={(idx % 3) * 0.08}>
        <div
            data-testid={`menu-item-${cid}-${idx}`}
            className="group flex h-full flex-col justify-between overflow-hidden rounded-xl border border-saga-red/15 bg-saga-creamlight shadow-[0_8px_32px_rgba(105,0,3,0.05)] transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-[0_16px_40px_rgba(105,0,3,0.1)]"
        >
            {item.image && (
                <div className="overflow-hidden">
                    <img
                        src={`/assets/${item.image}`}
                        alt={`${item.name} — Paan Saga`}
                        loading="lazy"
                        className="h-44 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                </div>
            )}
            <div className={`px-6 ${item.image ? "" : "pt-6"}`}>
                <div className="flex items-baseline justify-between gap-4">
                    <h4 className="font-display text-2xl font-semibold text-saga-ink">{item.name}</h4>
                    {item.kcal && (
                        <p className="shrink-0 text-[10px] font-semibold uppercase tracking-[0.15em] text-saga-ink/45">
                            {item.kcal} kcal
                        </p>
                    )}
                </div>
                <p className="mt-3 text-sm leading-relaxed text-saga-ink/65">{item.description}</p>
            </div>
            <span
                className="mx-6 mb-6 mt-5 block h-px w-10 bg-saga-red/25 transition-[width] duration-500 group-hover:w-[calc(100%-3rem)]"
                aria-hidden="true"
            />
        </div>
    </Reveal>
);

const MenuSection = () => (
    <section id="menu" data-testid="menu-section" className="scroll-mt-24 border-y hairline bg-saga-creamdark/40 py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <Reveal>
                <div className="max-w-2xl">
                    <p className="eyebrow">Menu</p>
                    <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-saga-red sm:text-5xl lg:text-6xl">
                        The Collections
                    </h2>
                    <p className="mt-6 text-base leading-relaxed text-saga-ink/70 sm:text-lg">
                        Six collections, one obsession — every paan 100% tobacco-free. For party and bulk enquiries, message us on
                        WhatsApp.
                    </p>
                </div>
            </Reveal>

            <div className="mt-20 space-y-24">
                {MENU_COLLECTIONS.map((collection, ci) => (
                    <div key={collection.id} id={`menu-${collection.id}`} className="scroll-mt-28">
                        <Reveal>
                            <div className="flex flex-wrap items-end justify-between gap-6">
                                <div>
                                    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-saga-ink/40">
                                        {String(ci + 1).padStart(2, "0")}
                                    </p>
                                    <h3 className="mt-2 font-display text-3xl font-semibold tracking-[0.04em] text-saga-red sm:text-4xl">
                                        {collection.name}
                                    </h3>
                                    <p className="mt-2 font-display text-lg italic text-saga-ink/60">{collection.note}</p>
                                </div>
                                <a
                                    href={WA.menu}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`menu-whatsapp-${collection.id}`}
                                    className="inline-flex items-center gap-2 rounded-full border border-saga-red/40 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] text-saga-red transition-colors hover:bg-saga-red hover:text-saga-cream"
                                >
                                    <WhatsAppIcon className="h-4 w-4" />
                                    Ask about this collection
                                </a>
                            </div>
                            <span
                                className="mt-6 block h-px w-full origin-left animate-line-grow bg-saga-red/20"
                                aria-hidden="true"
                            />
                        </Reveal>
                        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                            {collection.items.map((item, i) => (
                                <MenuCard key={item.name} item={item} idx={i} cid={collection.id} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default MenuSection;
